// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2zkV0","right":"styles_right__12NIE"};